import React from 'react';

import PlayerRecordCard from '~/components/PlayerRecordCard/PlayerRecordCard';
import StyledComponent from '~/components/Styled/Styled';

import getOr from '~/util/getOr';

import ResultsMap from '~/constants/ResultsMap';

import css from '~/components/PlayerRecords/PlayerRecords.scss';

type Props = {
  event: Event;
  playerRecordProperty: any;
};

class PlayerRecords extends React.Component<Props> {
  static displayName = 'PlayerRecords';

  leagueSlug = getOr(this.props, 'event.league.slug', '');
  eventStatus = getOr(this.props, 'event.event_status', '');

  renderPlayerRecordHeaders() {
    const playerHeader = ResultsMap[this.leagueSlug].player.label;
    // reversing a shallow copy of the statHeaders because 'float: right' is applied sequentially
    const statHeaders = (ResultsMap[this.leagueSlug].eventStats[this.eventStatus] || [])
      .slice(0)
      .reverse();
    return (
      <div className={css.headerContainer}>
        <div className={css.playerHeader}>{playerHeader}</div>
        {statHeaders.map(stat => (
          <div className={css.statHeader} key={stat.label}>
            {stat.label}
          </div>
        ))}
      </div>
    );
  }

  render() {
    const playerRecordProperty = `event.${ResultsMap[this.leagueSlug].player_records}`;
    const playerRecords = getOr(this.props, playerRecordProperty, []);
    if (this.eventStatus !== 'pre_game') {
      return (
        <div>
          {!!playerRecords.length && this.renderPlayerRecordHeaders()}
          {playerRecords.map(playerRecord => (
            <div key={playerRecord.id}>
              <PlayerRecordCard
                playerRecord={playerRecord}
                mappings={ResultsMap[this.leagueSlug]}
                eventStatus={this.eventStatus}
              />
            </div>
          ))}
        </div>
      );
    }
    return null;
  }
}

export default StyledComponent(PlayerRecords, [css]);
